import "./style.css";
import React, { lazy, Suspense, useState } from "react";
import Particles from "../Particles/Particles";
import mockTestThinkingImage from "../../assets/ietls-thinking.webp";
import TestForm from "../../Components/TestForm";

const Modal = lazy(() => import("../../Components/Modal/Modal"));

const MockTest = () => {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <Particles
        title="Know About Mock Test"
        subTitle="Information in Mock Test"
      />
      <div className="mock-test-information container">
        <div className="row">
          <div className="col-md-6 col-12 about-mock-test">
            <h2>What is Mock Test?</h2>
            <p>
              A Mock Test is a practice version of the real exam designed to
              simulate the actual test environment. It helps candidates
              understand the test format, experience time pressure, and identify
              their strengths and weaknesses.
            </p>
          </div>
          <div className="col-md-6 d-none d-md-block">
            <div className="image-container">
              <img src={mockTestThinkingImage} alt="mock-test-image" />
            </div>
          </div>
        </div>
        <div className="row justify-content-between px-0">
          <div className="col-12 col-lg-9">
            <div className="test-format">
              <h2>Why Take a Mock Test?</h2>
              <ol>
                <li>📝 Practice under real exam conditions</li>
                <li>🧠 Understand your readiness level</li>
                <li>📊 Get insights on your performance and score estimate</li>
                <li>⏱ Improve time management and reduce test-day anxiety</li>
              </ol>
            </div>
          </div>
          <div className="col-6 col-lg-3 mt-3 my-lg-4 align-items-start d-flex">
            <div className="register-card">
              <h1>Take Mock Test</h1>
              <button
                type="button"
                className="btn btn-md join-button"
                onClick={() => setShowModal(true)}
              >
                Join
              </button>
            </div>
          </div>
        </div>
      </div>
      {showModal && (
        <Suspense fallback={<></>}>
          <Modal
            showModal={showModal}
            setShowModal={setShowModal}
            header={"Join Mock Test"}
          >
            <TestForm
              setShowModal={setShowModal}
              preferredclassName="Mock Test"
            />
          </Modal>
        </Suspense>
      )}
    </>
  );
};

export default MockTest;
